import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { matthewsConfig } from "./data";

export default function MatthewsPage() {
  return <CityPageTemplate config={matthewsConfig} />;
}